
const newModel = () => {
    return {
        khomApId: null,
        ten: null,
        phuongXaId: null,
        tenPhuongXa: null,
        tinhTpId: null,
        tenTinhTp: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const newFEModel = () => {
    return {
        khomApId: null,
        ten: null,
        phuongXaId: null,
        tenPhuongXa: null,
        tinhTpId: null,
        tenTinhTp: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const fromJson = (item) => {
    return {
        khomApId: item.khomApId,
        ten: item.ten,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        tinhTpId: item.tinhTpId,
        tenTinhTp: item.tenTinhTp,
        quanHuyenId: item.quanHuyenId,
        tenQuanHuyen: item.tenQuanHuyen,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const parseModeltoFEModel = (item) => {
    return {
        khomApId: item.khomApId,
        ten: item.ten,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        tinhTpId: item.tinhTpId,
        tenTinhTp: item.tenTinhTp,
        quanHuyenId: item.quanHuyenId,
        tenQuanHuyen: item.tenQuanHuyen,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const errors = () => {
    return {
        khomApId: null,
        ten: null,
        phuongXaId: null,
        tenPhuongXa: null,
        tinhTpId: null,
        quanHuyenId: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const khomApModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


